import styled from 'styled-components'
// import {spacing} from '../../theme/spacing'

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-around;
`
